export default __webpack_public_path__ + "static/Fall2-b80979835449aadaf396e6b0e196ed14.mp3";